import React, { use, useEffect, useState } from 'react';
import { Box, Typography, IconButton, Slide, Tooltip, useTheme } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { AGENTIC_MS_USER_INFO } from '../../constants/appConstants';

interface DisclosureBarProps {
    message?: string;
}

const DisclosureBar: React.FC<DisclosureBarProps> = ({
    message
}) => {
    const [open, setOpen] = useState(true);
    const [collapse, setCollapse] = useState(false);
    const [disclosureMessage, setDisclosureMessage] = useState(message);
    const [user, setUser] = useState<any>();
    const { t } = useTranslation();
    const theme = useTheme();
    const location = useLocation();

    useEffect(() => {
        console.log(location.pathname);
        const userData: any = sessionStorage.getItem(AGENTIC_MS_USER_INFO);
        const parsedData = JSON.parse(userData);
        if (location.pathname === '/' || location.pathname === '/login' || location.pathname === '/azureAuth' || location.pathname === '/getToken') {
            setUser('');
        } else {
            setUser(parsedData?.roles && parsedData?.roles.length > 0 || '')
        }

    }, [location])

    useEffect(() => {
        if (message) {
            setDisclosureMessage(message);
        } else {
            setDisclosureMessage(t('common.aiContentsDisclosure'));
        }
    }, [message]);

    if (!user) {
        return null;
    }

    return (
        <>
            {/* Collapsed Icon */}
            {!open && (
                <Tooltip title={t('common.showAIDisclosure')}>
                    <Box
                        sx={{
                            position: 'fixed',
                            bottom: 10,
                            right: 10,
                            backgroundColor: theme.palette.priorityBorder.high,
                            color: 'white',
                            borderRadius: '50%',
                            width: 40,
                            height: 40,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            cursor: 'pointer',
                            boxShadow: 3,
                            zIndex: 1301,
                        }}
                        onClick={() => {
                            setCollapse(false);
                            setOpen(true);
                        }}
                    >
                        <InfoOutlinedIcon />
                    </Box>
                </Tooltip>
            )}

            {/* Disclosure Bar */}
            <Slide direction="up" in={open} onExited={() => setCollapse(true)} mountOnEnter unmountOnExit>
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 0,
                        left: 0,
                        width: collapse ? '0px' : '100%',
                        backgroundColor: theme.palette.priorityBorder.high,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        px: 2,
                        py: 1,
                        zIndex: 1300,
                    }}
                >
                    <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{disclosureMessage}</Typography>
                    <IconButton
                        size="small"
                        sx={{ color: 'white' }}
                        onClick={() => setOpen(false)}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Slide>
        </>
    );
};

export default DisclosureBar;